const KEY = 'wf:polls';
const MAX_ENTRIES = 100;

export type PollRole = 'owner' | 'respondent' | 'visitor';

export interface PollSummary {
  id: string;
  title: string;
  role: PollRole;
  lastVisited: number;
}

function rolePriority(role: PollRole): number {
  return role === 'owner' ? 3 : role === 'respondent' ? 2 : 1;
}

export function listPolls(): PollSummary[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr
      .filter((entry): entry is PollSummary => {
        if (!entry || typeof entry !== 'object') return false;
        const e = entry as Partial<PollSummary>;
        return (
          typeof e.id === 'string' &&
          typeof e.title === 'string' &&
          (e.role === 'owner' || e.role === 'respondent' || e.role === 'visitor') &&
          typeof e.lastVisited === 'number'
        );
      })
      .slice(0, MAX_ENTRIES);
  } catch {
    return [];
  }
}

export function rememberPoll(input: {
  id: string;
  title: string;
  role: PollRole;
  lastVisited?: number;
}): void {
  try {
    const all = listPolls();
    const prior = all.find((p) => p.id === input.id);
    const role =
      prior && rolePriority(prior.role) > rolePriority(input.role) ? prior.role : input.role;
    const merged: PollSummary = {
      id: input.id,
      title: input.title,
      role,
      lastVisited: input.lastVisited ?? Date.now(),
    };
    const others = all.filter((p) => p.id !== input.id);
    const next = [merged, ...others].slice(0, MAX_ENTRIES);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* noop */
  }
}

export function forgetPoll(id: string): void {
  try {
    const all = listPolls();
    const next = all.filter((p) => p.id !== id);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* noop */
  }
}
